export const QUERY_COUPON_CODE = 'promo_code';

export const STATUS_OBTAINED = 'OBTAIN_SUCCESS';
export const STATUS_NEED_LOGIN = 'LOGIN';
export const STATUS_INVALID = 'INVALID';